import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='movie' />
}

const skin = era.skin('routes/movies/details')

MovieDetailsPage.displayName = 'MovieDetailsPage'
export function MovieDetailsPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className='content-details-page'>
        <ui.RenderSkin name='bannersTypeVodDetails' />
        <ui.RenderSkin name='bannersTypeVodTrailer' />
        <ui.RenderSkin name='posterContent' />
        <ui.RenderSkin name='movieCategoryWithRecommended' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
